import { render, staticRenderFns } from "./CompanyProduct.vue?vue&type=template&id=d90b1044"
import script from "./CompanyProduct.vue?vue&type=script&lang=js"
export * from "./CompanyProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports